
<div class="cp-times">
  <div class="box-content" v-html="text"></div>
  <div class="box-bottom">
    <div class="bottom-item" @click="showShare"></div>
  </div>
  <Close is-mobile @close="onClose" class="close"></Close>
</div>
